import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { FaLeaf, FaCheckCircle, FaAward } from 'react-icons/fa';
import SectionTitle from '../../components/common/SectionTitle';
import { staggerContainer, delayTransition, enhancedViewport, simpleTransition } from '../../utils/animation';
import './HomeFeatures.scss';

// Icons mapping
const FEATURE_ICONS = [<FaLeaf />, <FaCheckCircle />, <FaAward />];

const HomeFeatures = () => {
  const { t } = useTranslation('home');
  const features = t('whyChooseUs.items', { returnObjects: true });
  
  // CLEANED: Eliminat useAnimation() inutil
  
  // Animații standardizate și optimizate
  const boxVariants = {
    hidden: { 
      opacity: 0,
      y: 50,
      scale: 0.9
    },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        delay: i * 0.2,
        duration: 0.6, // Standardizat
        ease: 'easeOut'
      }
    })
  };
  
  const iconVariants = {
    hidden: { scale: 0, rotate: -180 },
    visible: { 
      scale: 1, 
      rotate: 0,
      transition: { 
        type: 'spring', 
        stiffness: 60, 
        delay: 0.3, 
        duration: 0.6 
      }
    }
  };
  
  return (
    <section className="section features">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={simpleTransition}
          viewport={enhancedViewport}
        >
          <SectionTitle>{t('whyChooseUs.sectionTitle')}</SectionTitle>
        </motion.div>
        
        <motion.div 
          className="features__boxes"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={enhancedViewport}
        >
          {features.map((feature, index) => (
            <motion.div
              className="features__box"
              key={index}
              variants={boxVariants}
              custom={index}
              whileHover={{ 
                y: -15, 
                boxShadow: '0 30px 60px rgba(32,71,16,0.15), 0 15px 30px rgba(0,0,0,0.1)',
                transition: simpleTransition
              }}
            >
              <motion.div 
                className="features__icon"
                variants={iconVariants}
                whileHover={{ 
                  scale: 1.1, 
                  rotate: 5,
                  transition: simpleTransition
                }}
              >
                {FEATURE_ICONS[index]}
              </motion.div>
              <motion.h3 
                className="features__title"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={delayTransition(0.4 + index * 0.1)}
              >
                {feature.title}
              </motion.h3>
              <motion.p 
                className="features__description"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={delayTransition(0.6 + index * 0.1)}
              >
                {feature.description}
              </motion.p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default HomeFeatures;
